// DeleteConfirmationModal.tsx
import React from 'react';
import './CompanyManagement.css';

// Add these styles to CompanyManagement.css:
/*
.delete-modal-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: rgba(0, 0, 0, 0.5) !important;
  z-index: 1050 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 20px !important;
}

.delete-modal-container {
  background: #ffffff !important;
  border-radius: 8px !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2) !important;
  max-width: 400px !important;
  width: 100% !important;
  margin: 0 auto !important;
}

.delete-modal-content {
  padding: 32px !important;
  text-align: center !important;
}

.delete-modal-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #374151 !important;
  margin: 0 0 16px 0 !important;
  line-height: 1.3 !important;
}

.delete-modal-message {
  font-size: 16px !important;
  color: #6b7280 !important;
  margin: 0 0 32px 0 !important;
  line-height: 1.5 !important;
}

.company-name-highlight {
  font-weight: 600 !important;
  color: #374151 !important;
}

.delete-modal-actions {
  display: flex !important;
  gap: 12px !important;
  justify-content: center !important;
}

.btn-cancel-delete,
.btn-confirm-delete {
  padding: 12px 24px !important;
  border-radius: 6px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  border: none !important;
  min-width: 100px !important;
  height: 44px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-cancel-delete {
  background: #ffffff !important;
  color: #374151 !important;
  border: 1px solid #d1d5db !important;
}

.btn-cancel-delete:hover:not(:disabled) {
  background: #f9fafb !important;
  border-color: #9ca3af !important;
}

.btn-confirm-delete {
  background: #dc2626 !important;
  color: #ffffff !important;
  border: 1px solid #dc2626 !important;
}

.btn-confirm-delete:hover:not(:disabled) {
  background: #b91c1c !important;
  border-color: #b91c1c !important;
}

@media (max-width: 480px) {
  .delete-modal-content {
    padding: 24px !important;
  }
  
  .delete-modal-actions {
    flex-direction: column !important;
  }
  
  .btn-cancel-delete,
  .btn-confirm-delete {
    width: 100% !important;
  }
}
*/

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  companyName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  companyName,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-container">
        <div className="delete-modal-content">
          <h2 className="delete-modal-title">Delete Company</h2>
          <p className="delete-modal-message">
            Are you sure you want to delete "<span className="company-name-highlight">{companyName}</span>"?
          </p>
          <div className="delete-modal-actions">
            <button
              onClick={onConfirm}
              className="btn-confirm-delete"
              type="button"
            >
              Delete
            </button>
            <button
              onClick={onCancel}
              className="btn-cancel-delete"
              type="button"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};